export default __webpack_public_path__ + "static/media/background.f4b196f1.png";